module.exports = __webpack_public_path__ + "static/media/icita2015.59d3a75d.png";